import React from "react";
import axios from "axios";
import config from "config";
// components

import CardTable from "components/Tables/CardTable.js";

export default function Orders() {

    const url = `${config.baseUrl}${config.apiEndpoints.listOrders}`;
    const [orders, setOrders] = React.useState([]);
    const [columns, setColumns] = React.useState([
        // { label: "Order ID", key: "id", render: (value) => <b>{value}</b> },
        { label: "Customer", key: "customer", render: (value) => <span>{value}</span> },
        { label: "Total", key: "total", render: (value) => <span>{value}</span> },
        { label: "Delivery Date", key: "delivery_date", render: (value) => <span>{value}</span> }
    ]);
    
    React.useEffect(() => {
        axios.get(url)
            .then((response) => {
                setOrders(response.data);
            })
            .catch((error) => {
                console.log(error);
            });
    }, []);

    return (
        <>
            <div className="flex flex-wrap mt-4">
                <div className="w-full mb-12 px-4">
                    <CardTable
                        color="light"
                        heading="Orders"
                        route="/admin/orders/create"
                        columns={columns}
                        data={orders}
                    />
                </div>
            </div>
        </>
    );
}